const axios = require('axios')
let _baseUrl = '/usercenterservice'

// 获取通知列表
export function getNoticeList (query) {
  const url = _baseUrl + '/notice/getNoticeList' + query
  return axios.get(url).then((res) => {
    return Promise.resolve(res.data)
  })
}

// 批量读取通知
export function readNotice (query, data) {
  const url = _baseUrl + '/notice/readNotice' + query
  return axios.post(url, data).then((res) => {
    return Promise.resolve(res.data)
  })
}

// 读取所有通知
export function readAllNotice (query) {
  const url = _baseUrl + '/notice/readAllNotice' + query
  return axios.post(url).then((res) => {
    return Promise.resolve(res.data)
  })
}

// 获取用户未读通知个数服务接口
export function getNewNoticeCount (query) {
  const url = _baseUrl + '/notice/getNewNoticeCount' + query
  return axios.get(url, query).then((res) => {
    return Promise.resolve(res.data)
  })
}
